import { useCallback } from 'react';
import { useDispatch } from 'store/hooks';
import { drilldownAsync } from 'widgets/portfolioSummary/store/data/thunks';
import { AggregationField } from 'widgets/portfolioSummary/aggregation/fields/aggregationFieldPortfolio';
import { PortfolioSummaryDrillDown } from 'widgets/portfolioSummary/store/instances/component/PortfolioSummaryComponentState';
import { useWidgetContext } from 'widgets/WidgetContext';

export const useDispatchDrillDown = () => {
    const dispatch = useDispatch();
    const { widgetKey } = useWidgetContext();

    return useCallback(
        (
            aggregationField: AggregationField,
            drillDown: PortfolioSummaryDrillDown
        ) => {
            dispatch(drilldownAsync(widgetKey, aggregationField, drillDown));
        },
        [dispatch, widgetKey]
    );
};
